// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1eF9n","header":"MessagesList_header__3EMGH","chat":"MessagesList_chat__r7d2T"};